import {QUALITY_ERROR, QUALITY_SUCCESS} from '../actions/quality_usage_class';

const initialState = {
    all: {},
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === QUALITY_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === QUALITY_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}
